module.exports = {
    seo: {
        home: {
            am: {
                title: 'Ստեղծել ռեզյումե աշխատանքի համար, աշխատանքային ինքնակենսագրական, resume dzev, cv orinak',
                description: 'CV Web-ը մի հարթակ է, որտեղ յուրաքանչյուր աշխատանք փնտրող կարող է կազմել ռեզյումե, ներբեռնել PDF ֆորմատով։ Կայքում առկա ռեզյումեի օրինակները այնքան հարմարավետ են և կրեատիվ, որ կգոհացնեն անգամ ամենաբծախնդիր այցելուին։'
            },
            ru: {
                title: 'Создать резюме онлайн бесплатно на работу, образец резюме, Резюме профессии',
                description: 'Сайт CVWeb – это огромный портал с удобным интерфейсом, где каждый соискатель может найти для себя бланк резюме. У нас вы найдете советы как составить резюме правильно. Всего за 5 минут создайте резюме на работу онлайн, и что главное – бесплатно.'
            },
            en: {
                title: 'Online resume format, cv examples for job, resume tips, resume free download',
                description: 'CVweb is professional resume making service, it offers you the best examples of resume. With CVweb you can write objective for resume and study how to make resume for job. Resume forms are so simple that even students can write resume examples for work.'
            }
        },
        homeForgot: {
            am: {
                title: 'Ստեղծել ռեզյումե աշխատանքի համար, աշխատանքային ինքնակենսագրական, resume dzev, cv orinak',
                description: 'CV Web-ը մի հարթակ է, որտեղ յուրաքանչյուր աշխատանք փնտրող կարող է կազմել ռեզյումե, ներբեռնել PDF ֆորմատով։ Կայքում առկա ռեզյումեի օրինակները այնքան հարմարավետ են և կրեատիվ, որ կգոհացնեն անգամ ամենաբծախնդիր այցելուին։'
            },
            ru: {
                title: 'Создать резюме онлайн бесплатно на работу, образец резюме, Резюме профессии',
                description: 'Сайт CVWeb – это огромный портал с удобным интерфейсом, где каждый соискатель может найти для себя бланк резюме. У нас вы найдете советы как составить резюме правильно. Всего за 5 минут создайте резюме на работу онлайн, и что главное – бесплатно.'
            },
            en: {
                title: 'Online resume format, cv examples for job, resume tips, resume free download',
                description: 'CVweb is professional resume making service, it offers you the best examples of resume. With CVweb you can write objective for resume and study how to make resume for job. Resume forms are so simple that even students can write resume examples for work.'
            }
        },
        blog: {
            am: {
                title: 'Որտեղ փնտրել աշխատանք, թափուր աշխատատեղեր, cv հայերեն, ռեզյումե',
                description: 'CVweb բլոգի օգտակար խարհուրդներին հետևելով, կազմեք անթերի ռեզյումե Ձեր նախընտրած աշխատանքի համար։'
            },
            ru: {
                title: 'CVweb блог, советы как составить резюме',
                description: 'В блоге CVweb найдите самые важные советы как создать резюме на работу, у вас будет самый эффективный и качественный пример резюме.'
            },
            en: {
                title: 'Advices for creating resume models',
                description: 'In CVweb blog we include the most useful advices for making resume for job.'
            }
        },
        profile: {
            am: {
                title: 'Պրոֆիլ',
                description: ''
            },
            ru: {
                title: 'Профиль',
                description: ''
            },
            en: {
                title: 'Profile',
                description: ''
            }
        },
        'cv-edit': {
            am: {
                title: 'edit Am',
                description: ''
            },
            ru: {
                title: 'edit ru',
                description: ''
            },
            en: {
                title: 'edit en',
                description: ''
            }
        },

        'cv-create-b-1': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-s-1': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-s-2': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-s-3': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-p-1': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-p-2': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-u-1': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'cv-create-u-2': {
            am: {
                title: 'Ստեղծել աշխատանքային ռեզյումե',
                description: 'Cvweb-ի առաջարկած հարմարավետ ռեզյումեի օրինակները կօգնեն յուրաքանչյուրին կազմել ինքնատիպ ինքնակենսագրական աշխատանքի համար։'
            },
            ru: {
                title: 'Создать резюме на работу: бланк, примеры, советы',
                description: 'С помощью уникальних резюме которые вам предлогает сайт CVWeb, создайте для себя резюме на работу и по префессии. В нашем онлайн сервисе бесплатно составите резюме и скачайте в формате PDF'
            },
            en: {
                title: 'Create your CV template for job',
                description: 'Cvweb offers you the unique tipes of resume for work. Make an online resume via our service and download it in PDF format for free.'
            }
        },
        'blog.category': {
            am: {
                title: 'blog.category Am',
                description: ''
            },
            ru: {
                title: 'blog.category ru',
                description: ''
            },
            en: {
                title: 'blog.category en',
                description: ''
            }
        },
        'blog.category.post': {
            am: {
                title: 'blog.category.post Am',
                description: ''
            },
            ru: {
                title: 'blog.category.post ru',
                description: ''
            },
            en: {
                title: 'blog.category.post en',
                description: ''
            }
        },
        'contacts': {
            am: {
                title: 'Հետադարձ կապ',
                description: 'Դեռ մնացել են հարցեր՞, ունեք առաջարկներ կամ բողոքներ՞, կարեղ եք հետադարձ կապ հաստատել մեզ հետ, և մեր բարեխիղճ մասնագետները կպատասխանեն Ձեր բոլոր հարցերին։'
            },
            ru: {
                title: 'Обратный связь, свяжитесь с нами',
                description: 'По-прежнему остались вопросы как составить резюме на работу или у вас есть предложение? Просто напишите нам. Мы всегда рады вам помочь.'
            },
            en: {
                title: 'Contact us, Our contacts',
                description: 'If you have any questions just contact us. We are happy to help you.'
            }
        },
        'faq': {
            am: {
                title: 'Հաճախ տրվող հարցեր',
                description: 'Հաճախ տրվող հարցերի օգտակար պատասխանների շնորհիվ, կազմեք ձեր աշխատանքային ինքնակենսագրականները։'
            },
            ru: {
                title: 'Часто задаваемые вопросы',
                description: 'В разделе часто задаваемые вопросы можете найти ответы на ваши вопросы – как написать правильный образец резюме.  '
            },
            en: {
                title: 'Frequently asked questions',
                description: 'Find the answers on your questions in Frequently asked questions section.'
            }
        },
        'about_us': {
            am: {
                title: 'about_us Am',
                description: ''
            },
            ru: {
                title: 'about_us ru',
                description: ''
            },
            en: {
                title: 'about_us en',
                description: ''
            }
        },
        'payment': {
            am: {
                title: 'payment Am',
                description: ''
            },
            ru: {
                title: 'payment ru',
                description: ''
            },
            en: {
                title: 'payment en',
                description: ''
            }
        },
        'error_404': {
            am: {
                title: 'error_404 Am',
                description: ''
            },
            ru: {
                title: 'error_404 ru',
                description: ''
            },
            en: {
                title: 'error_404 en',
                description: ''
            }
        },
        'vacancy': {
            am: {
                title: 'vacancy Am',
                description: ''
            },
            ru: {
                title: 'vacancy ru',
                description: ''
            },
            en: {
                title: 'vacancy en',
                description: ''
            }
        },
        'policy': {
            am: {
                title: 'Գաղտնիության քաղաքականություն',
                description: 'policy'
            },
            ru: {
                title: 'Политика конфиденциальности',
                description: 'policy'
            },
            en: {
                title: 'Confidentiality policy',
                description: 'policy'
            }
        },
        'map': {
            am: {
                title: 'Map',
                description: 'Map'
            },
            ru: {
                title: 'Map',
                description: 'Map'
            },
            en: {
                title: 'Map',
                description: 'Map'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/config.js